import React, { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import { Button, Modal, Table, message } from "antd";
import {
  useGetCustomersQuery,
  useDeleteCustomersMutation,
} from "../../../redux/Service/api";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Heading from "../../../Components/Heading/Heading";
import ServerError from "../../../Components/utils/ServerError";
import dayjs from "dayjs";

interface Customer {
  id: number;
  CustomerName: string;
  Address: string;
  Phone: string;
  Mobile: string;
  Email: string;
  FirstBalDate: string;
}

const { confirm } = Modal;

const Customer: React.FC = () => {
  const [deleteCustomer, { isLoading: delIsLoading }] =
    useDeleteCustomersMutation();

  const {
    data: customersData,
    isError: isCustomersError,
    isLoading: isCustomersLoading,
  } = useGetCustomersQuery(undefined);

  const customers: Customer[] = customersData?.data ?? [];

  const handleDeleteCustomer = (id: number) => {
    confirm({
      title: "هل أنت متأكد أنك تريد حذف هذا العميل؟",
      icon: <ExclamationCircleFilled />,
      content: "بالضغط على موافق سيتم حذف العميل بشكل دائم.",
      async onOk() {
        try {
          await deleteCustomer(id);
          message.success("تم حذف العميل بنجاح");
        } catch (error) {
          console.error(error);
          message.error("فشل في حذف العميل.");
        }
      },
    });
  };

  const columns = [
    {
      title: "رقم العميل",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "اسم العميل",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "العنوان",
      dataIndex: "Address",
      key: "Address",
    },
    {
      title: "الهاتف",
      dataIndex: "phone",
      key: "phone",
    },
    // {
    //   title: "الجوال",
    //   dataIndex: "Mobile",
    //   key: "Mobile",
    // },
    {
      title: "البريد الإلكتروني",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "تاريخ التسجيل",
      dataIndex: "created_at",
      key: "created_at",
      render: (date: string) => dayjs(date).format("YYYY-MM-DD"),
    },
    {
      title: "الإجراءات",
      key: "actions",
      render: (_: any, customer: Customer) => (
        <div className="flex gap-2">
          <Button
            type="text"
            icon={<DeleteFilled />}
            danger
            onClick={() => handleDeleteCustomer(customer.id)}
          />
        </div>
      ),
    },
  ];

  return (
    <section className="p-4 section_padding mt-0 pt-0 relative">
      <Heading heading="العملاء" />

      {isCustomersError && <ServerError />}

      <div className="mx-auto">
        <Table
          bordered
          columns={columns}
          dataSource={customers}
          rowKey="CustomerID"
          loading={isCustomersLoading || delIsLoading}
          // pagination={{ pageSize: 5 }}
          scroll={{ y: 450 }}
        />
      </div>
    </section>
  );
};

export default Customer;
